import { useState } from "react";
import Sidebar from "@/pages/sidebar/sidebar";
import ClientMainHeader from "@/pages/header";
import { MainWrapper } from "@/pages/styled";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { InvoicePreview } from "./components/invoice-preview";
import { breakpoints } from "@/ui/breakpoints";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { LimitedAccountWarning } from "@/components/limited-account-warning";
import { MerchantProcessingBanner } from "@/components/merchant-processing-banner";
import Loading from "@/components/ui/loading";
import { CreateInvoiceForm } from "@/components/invoices/create-invoice-form/create-invoice-form";
import { CreateInvoiceProvider } from "@/components/invoices/create-invoice-form/create-invoice-context";
import { PreviewButton } from "@/components/invoices/create-invoice-form/preview-button";
import { Button } from "@/components/ui/button-tw";
import { ArrowLeftIcon, EyeOff } from "lucide-react";

const NewInvoice = () => {
  const [currentWidth, setCurrentWidth] = useState(0);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [currentFormData, setCurrentFormData] = useState(null);

  return (
    <CreateInvoiceProvider
      formData={currentFormData}
      isPreviewOpen={isPreviewOpen}
      setIsPreviewOpen={setIsPreviewOpen}
    >
      <div className="min-h-full">
        <Sidebar
          currentWidth={currentWidth}
          setCurrentWidth={setCurrentWidth}
        />

        <LimitedAccountWarning />
        <MerchantProcessingBanner />
        <div className="relative lg:ml-80 h-full  bg-gray-50 px-0 md:px-3 pt-4 md:pt-6 xl:pt-8 pb-12 xl:px-6 2xl:px-8 lg:pb-32">
          <div className="max-w-[1720px] mx-auto">
            <div className="flex justify-between items-center mb-4 md:mb-6 xl:mb-8 px-4 md:px-0">
              <div className="flex gap-x-2 items-center">
                <span className="text-xl md:text-3xl font-medium text-gray-900">
                  Create Invoice
                </span>
              </div>
              <div className="flex gap-x-4 ">
                <PreviewButton />
              </div>
            </div>
            <div className="mx-auto grid grid-cols-5 gap-0 md:gap-6 items-start ">
              <CreateInvoiceForm onFormDataChange={setCurrentFormData} />
            </div>
          </div>
        </div>
      </div>
    </CreateInvoiceProvider>
  );
};

export default NewInvoice;
